var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"items":_vm.items,"loading":_vm.loading,"value":_vm.value,"error-messages":[..._vm.errors, ..._vm.errorMessages],"hide-details":_vm.hideDetails},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }